// IE11 Polyfills
import 'core-js/features/array/find'
import 'core-js/features/array/find-index'
import 'core-js/features/array/from'
import 'core-js/features/object/assign'
import 'core-js/features/promise'
import 'core-js/features/reflect'
import 'core-js/features/string/ends-with'

// import { Provider } from 'react-redux'
// import { createStore, applyMiddleware } from 'redux'

// Configuration. Don't delete this.
import './internal/configure'
import './configure'

import React from 'react'
import ReactDOM from 'react-dom'
import SolutionBreadcrumb from './components/SolutionBreadcrumb'
import SolutionFinder from './components/SolutionFinder'
import { createLogger } from 'redux-logger'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import rootReducer from './components/rootReducer'
const logger = createLogger({
  collapsed: true,
  duration: true,
  diff: true,
})

// This JS will execute at the end of every page that your custom experience
// component is referenced from. Be careful that you correctly scope your JS to
// your component.
const store = createStore(rootReducer, applyMiddleware(logger))

const SolutionFinderNode = document.querySelector(
  '.trtaSolutionFinder-CecTrtaSolutionFinder',
)
const SolutionBreadcrumbNode = document.querySelector(
  '.trtaSolutionFinder-CecTrtaSolutionBreadcrumb',
)
//<Provider store={store}></Provider>
if (SolutionFinderNode) {
  ReactDOM.render(
    <Provider store={store}>
      <SolutionFinder />
    </Provider>,
    SolutionFinderNode,
  )
} else if (SolutionBreadcrumbNode) {
  ReactDOM.render(
    <Provider store={store}>
      <SolutionBreadcrumb useLocalStorage expanded />
    </Provider>,
    SolutionBreadcrumbNode,
  )
}



// WEBPACK FOOTER //
// ./js/main.js